import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from 'formlabs-web-components/Type';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Picture } from 'formlabs-web-components/Media';
import { Eyebrow } from 'formlabs-web-components/Type';
import { Button, Link } from 'formlabs-web-components/Link';
import TextPlugin from '../cms/TextPlugin';
import CenterModal from '../modal/CenterModal';
import './ambassadors.module.css';

const Ambassador = ({
  image,
  name,
  title,
  company,
  bio,
  social,
  blogURL,
  blogCTA,
  index
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleLinkClick = e => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Cell key={index} largeSize={6} mediumSize={12} styleName="ambassador">
      <Picture largeImage={image} width="100%" alt={name} />
      <Header level={4} displayAs={5} weight={400}>
        {name}
      </Header>
      <p styleName="title">{title}</p>
      <Eyebrow>{company}</Eyebrow>
      {bio && (
        <div styleName="bio">
          <TextPlugin body={bio} />
          <button styleName="link" onClick={handleLinkClick}>
            {t('Learn More')} <i className="fl-navigate_next" />
          </button>
        </div>
      )}
      {open ? (
        <CenterModal onClose={handleClose} width="1200px">
          <Grid direction="x" gutters="padding">
            <Cell largeSize={8} mediumSize={12}>
              <Picture largeImage={image} width="100%" alt={name} />
            </Cell>
            <Cell largeSize={16} mediumSize={12}>
              <Header level={4} displayAs={5} weight={400}>
                {name}
              </Header>
              <p styleName="title">{title}</p>
              <Eyebrow>{company}</Eyebrow>
              <TextPlugin body={bio} />
              {blogURL && (
                <p>
                  <Button url={blogURL} arrow="right">
                    {blogCTA || t('Read our blog post')}
                  </Button>
                </p>
              )}
              {social.length > 0 && (
                <ul styleName="social-list">
                  {social.map(social => (
                    <Link to={social.url}>
                      <li key={social.url}>
                        <i className={`fl-${social.platform}`} />
                      </li>
                    </Link>
                  ))}
                </ul>
              )}
            </Cell>
          </Grid>
        </CenterModal>
      ) : null}
    </Cell>
  );
};

export default Ambassador;
